import React from "react";
import { CheckCircle2 } from "lucide-react";

export const Field = ({
  label,
  name,
  type = "text",
  required = false,
  value,
  onChange,
  placeholder,
  error,
  autoComplete,
  testId,
}) => (
  <div>
    <label className="field-label" htmlFor={name}>
      {label} {required && <span style={{ color: "#B08A4B" }}>*</span>}
    </label>
    <input
      id={name}
      name={name}
      type={type}
      className="field-input"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      autoComplete={autoComplete}
      aria-invalid={error ? "true" : undefined}
      aria-describedby={error ? `${name}-error` : undefined}
      data-testid={testId || `field-${name}`}
    />
    {error && (
      <p className="field-error" id={`${name}-error`} data-testid={`error-${name}`}>
        {error}
      </p>
    )}
  </div>
);

export const TextAreaField = ({
  label,
  name,
  required = false,
  value,
  onChange,
  placeholder,
  error,
  rows = 4,
  testId,
}) => (
  <div>
    <label className="field-label" htmlFor={name}>
      {label} {required && <span style={{ color: "#B08A4B" }}>*</span>}
    </label>
    <textarea
      id={name}
      name={name}
      rows={rows}
      className="field-input"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      aria-invalid={error ? "true" : undefined}
      aria-describedby={error ? `${name}-error` : undefined}
      data-testid={testId || `field-${name}`}
    />
    {error && (
      <p className="field-error" id={`${name}-error`} data-testid={`error-${name}`}>
        {error}
      </p>
    )}
  </div>
);

export const SelectField = ({
  label,
  name,
  required = false,
  value,
  onChange,
  options = [],
  placeholder = "Select an option",
  error,
  testId,
}) => (
  <div>
    <label className="field-label" htmlFor={name}>
      {label} {required && <span style={{ color: "#B08A4B" }}>*</span>}
    </label>
    <select
      id={name}
      name={name}
      className="field-input"
      value={value}
      onChange={onChange}
      aria-invalid={error ? "true" : undefined}
      aria-describedby={error ? `${name}-error` : undefined}
      data-testid={testId || `field-${name}`}
    >
      <option value="">{placeholder}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
    {error && (
      <p className="field-error" id={`${name}-error`} data-testid={`error-${name}`}>
        {error}
      </p>
    )}
  </div>
);

export const FormSuccess = ({ title, message, children, testId = "form-success" }) => (
  <div
    data-testid={testId}
    role="status"
    className="rounded-[18px] border p-8 sm:p-10"
    style={{ background: "var(--lykit-lavender)", borderColor: "rgba(216,183,122,0.45)" }}
  >
    <CheckCircle2 size={26} strokeWidth={1.5} style={{ color: "#352A59" }} aria-hidden="true" />
    <h3 className="display-md mt-5" style={{ color: "#352A59" }}>
      {title}
    </h3>
    <p className="mt-4 max-w-[52ch] text-[15px] leading-[1.66] body-muted">{message}</p>
    {children && <div className="mt-8">{children}</div>}
  </div>
);
